// removed by extract-text-webpack-plugin
module.exports = {"list":"kj_ce pKdTL18pM3P4XKY2kq_Ub"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventTicketsPage/components/TicketList/styles.module.css
// module id = 1338
// module chunks = 27